function initProductPixelGalleries() {
  document.querySelectorAll('[data-product-gallery]').forEach(function (galleryRoot) {
    if (galleryRoot.dataset.galleryReady === 'true') return;

    const mainImage =
      galleryRoot.querySelector('[data-product-gallery-main]') ||
      galleryRoot.querySelector('.product-information--pixel__main-media img');
    const thumbs = galleryRoot.querySelectorAll('[data-product-gallery-thumb]');
    if (!mainImage || !thumbs.length) return;

    galleryRoot.dataset.galleryReady = 'true';

    galleryRoot.addEventListener('click', function (event) {
      const thumb = event.target.closest('[data-product-gallery-thumb]');
      if (!thumb || !galleryRoot.contains(thumb)) return;

      event.preventDefault();

      const nextSrc = thumb.getAttribute('data-image-src');
      if (!nextSrc) return;

      mainImage.src = nextSrc;

      const nextSrcset = thumb.getAttribute('data-image-srcset');
      if (nextSrcset) {
        mainImage.srcset = nextSrcset;
      } else {
        mainImage.removeAttribute('srcset');
      }

      const nextAlt = thumb.getAttribute('data-image-alt');
      if (nextAlt) {
        mainImage.alt = nextAlt;
      }

      thumbs.forEach(function (item) {
        const isActive = item === thumb;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductPixelGalleries);
} else {
  initProductPixelGalleries();
}

document.addEventListener('shopify:section:load', initProductPixelGalleries);
